// Side-effect import: registers organic module hooks with the central module registry
// before the schema-driven UI renders.
import "../hooks";

import { ClientModuleDetailPage } from "@/features/integrations/modules/pages/ClientModuleDetailPage";

function OrganicJobDeliveryClientDetailPage() {
  return (
    <ClientModuleDetailPage
      moduleName="organic"
      moduleSubKey="organic"
      showTitle
    />
  );
}

export default OrganicJobDeliveryClientDetailPage;
